export default __webpack_public_path__ + "static/media/edit.a66010fb.svg";